export default __webpack_public_path__ + "static/media/head04_ko_pc.785379d2.png";